var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseInfo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.95431 0 20V100C0 111.046 8.95431 120 20 120H100C111.046 120 120 111.046 120 100V20C120 8.95431 111.046 0 100 0H20ZM62.976 42.064C68.8523 42.064 73.616 37.5725 73.616 32.032C73.616 26.4915 68.8523 22 62.976 22C57.0997 22 52.336 26.4915 52.336 32.032C52.336 37.5725 57.0997 42.064 62.976 42.064ZM43.216 58.784C43.216 54.5866 46.6186 51.184 50.816 51.184H64.192C68.3894 51.184 71.792 54.5866 71.792 58.784C71.792 59.3045 71.7397 59.8129 71.64 60.304C71.7397 60.7951 71.792 61.3035 71.792 61.824V82.8542C75.5594 83.3047 78.48 86.5113 78.48 90.4C78.48 94.5974 75.0774 98 70.88 98H49.6C45.4026 98 42 94.5974 42 90.4C42 86.2026 45.4026 82.8 49.6 82.8H56.592V66.384H50.816C46.6186 66.384 43.216 62.9814 43.216 58.784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseInfo1);
export default __webpack_public_path__ + "static/media/license_info1.c8606fcb1f446c8358e9104631751963.svg";
export { ForwardRef as ReactComponent };